import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Icon } from '~/components'

import { Timestamps, TextEdit } from '~/services'

import { toggleArticleFlare } from '~/actions/article'


class Video extends React.Component {
    static propTypes = {
		date: PropTypes.string.isRequired,
		preview: PropTypes.object.isRequired
	};

    state = {
        flared: !!this.props.flared
    };

    flare = () => {
		this.props.toggleArticleFlare(this.props.post.ID)
		this.setState({
			flared: !this.state.flared
		})
	};

    render() {

		return (
			<Link to={this.props.preview.data.url} className="no-style" state={{video: this.props}}>
				<div className="post-preview__img">
					<img src={this.props.preview.data.image} alt={this.props.preview.data.title} />
				</div>
				<footer className="post-preview__content">

					<h5 className="text-center">Video</h5>

					<h3 className="mtop0 mbot15">{this.props.preview.data.title}</h3>

					<p className="small details text-dark-gray text-center">
						{'Posted ' + Timestamps.timeSince(this.props.date, true)}
					</p>

				</footer>
			</Link>
		)
		
	}
}

const mapStateToProps = state => ({
    ...state
});

const mapDispatchToProps = dispatch => bindActionCreators({ toggleArticleFlare }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Video);




// WEBPACK FOOTER //
// ./src/js/views/Discover/scenes/Filtered/components/Video.js